module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "promotion_test_drive.df9eecf1.png";